import { Inject, Injectable } from '@angular/core';
import activeInsuranceGroups from '@assets/active-insurance-groups.json';
import inactiveProducts from '@assets/inactive-products.json';
import inactiveProductsTest from '@assets/inactive-products-test.json';
import languages from '@assets/languages.json';
import policyStates from '@assets/policy-states.json';
import claimStates from '@assets/claim-states.json';
import paymentSources from '@assets/payment-sources.json';
import paymentModes from '@assets/payment-modes.json';
import paymentFrequency from '@assets/payment-frequency.json';
// import correspondenceGroups from '@assets/correspondence-groups.json';
import emailUsTopics from '@assets/email-us-topics.json';
import emailUsNavList from '@assets/email-us-navlist.json';


import { ActiveInsuranceGroup } from '@shared/models/active-insurance-group';
import { InactiveProduct } from '@shared/models/inactive-product';
//import { MenuItem } from '@shared/models/menu-item';
import { Language } from '@shared/models/language';
import { PolicyStates } from '@shared/models/codebooks/policy-state';
import { ClaimStates } from '@shared/models/codebooks/claim-state';
import { Codebooks } from '@shared/models/codebooks/codebooks';
import { UserRole } from '@shared/models/codebooks/user-role';
import { EnvironmentConfig, ENV_CONFIG } from '@core/environment-config.interface';
// import { CorrespondenceGroup } from '@shared/models/correspondence-group';
import { EmailUsTopics } from '@shared/models/email-us-topics';
import { EmailUsNavList } from '@shared/models/email-us-navlist';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    public inactiveProducts: InactiveProduct[];
    public activeInsuranceGroups: ActiveInsuranceGroup[];
    //public topbarMenu: MenuItem[];
    public languages: Language[];
    public policyStates: PolicyStates;
    public claimStates: ClaimStates;
    //  public correspondenceGroups: CorrespondenceGroup[];
    public codebooks: Codebooks;
    public emailUsTopics: EmailUsTopics;
    public emailUsNavList: EmailUsNavList[];

    public environmentConfig: EnvironmentConfig;

    public notOpenedEmails: BehaviorSubject<number> = new BehaviorSubject(0);
    public inboxSelectedComponent: string;

    constructor(
        @Inject(ENV_CONFIG) private config: EnvironmentConfig
    ) {

        this.inactiveProducts = inactiveProducts;
        if (!config.production) {
            this.inactiveProducts = inactiveProductsTest;
        }

        this.activeInsuranceGroups = activeInsuranceGroups;
        //this.topbarMenu = topbarMenu;
        this.languages = languages;
        this.policyStates = policyStates;
        this.claimStates = claimStates;
        // this.correspondenceGroups = correspondenceGroups;
        this.codebooks = new Codebooks();

        this.codebooks.paymentSources = paymentSources;
        this.codebooks.paymentModes = paymentModes;
        this.codebooks.paymentFrequency = paymentFrequency;

        this.emailUsTopics = emailUsTopics;
        this.emailUsNavList = emailUsNavList;

        this.environmentConfig = config;
    }

    groupByKey(array: any[], key: string): any {
        return array
            .reduce((rv, x) => {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
    }
}
